export const environment = {
  production: false,
  apiUrl: 'https://back.solnativo.eu',
  title: 'dev-sol',
  recapKey: '6LfkeLUpAAAAAB3YIifH5aO7K3EVruGrE27Ad6Aw',
};
